// I tipi che il tavolo della briscola legge. La TMA NON importa QBriscola: sono COPIATI A MANO da Qlash-IT/QBriscola @ 43dd0c5f51e1272d1f20eee94993826de48e7ad5
// (main, 2026-10-20), uno per file:
//   · Posto, Linea, Config, Fase, Giocata, Presa, Riepilogo, Vista — packages/regole/src/tipi.ts (la Vista e quella del motore: MAI la mano altrui, salvo quella del
//     compagno a tallone finito nel 2v2 (I-835); MAI l'ordine del tallone; MAI le carte prese; degli altri si sa solo QUANTE carte hanno, `carteInMano`). `Stato` e
//     `Azione` del motore NON si copiano: sono del server; di `Azione` resta la sola mossa di una persona, `GIOCA`.
//   · Carta — packages/regole/src/carte.ts (un intero 0..39: `seme * 10 + grado - 1`, semi denari, coppe, spade, bastoni).
//   · AzioneDiPersona — packages/regole/src/tipi.ts `Azione` (`GIOCA`) + apps/qbriscola-gameserver/src/regole.ts `puòAgire`: le chiavi sono ESATTAMENTE `t`, `posto`,
//     `carta` (un'altra chiave e `AZIONE_MALFORMATA`); `DISTRIBUISCI`, `RACCOGLI`, `UFFICIO` e `ABBANDONO` sono del server (`AZIONE_DEL_SERVER`).
//   · MOTIVI — apps/qbriscola-gameserver/src/regole.ts `MOTIVI` (i sotto-codici che un rifiuto puo portare in `reason`).
// Del trasporto (la busta di stato, gli eventi, la mescolata verificabile) NON c'e niente qui: e `src/lib/gamehost/protocol.ts`.

/** Un posto (0..3) e una linea (chi segna insieme: il giocatore nel 1v1, la coppia {0,2} o {1,3} nel 2v2). */
export type Posto = number;
export type Linea = number;
/** Una carta e un intero 0..39: `seme * 10 + grado - 1`. */
export type Carta = number;
export type Fase = 'da-distribuire' | 'in-gioco' | 'finita';

export interface Config {
  /** le smazzate da vincere per vincere la partita: 2 = «2 su 3» (I-832). Una smazzata 60-60 non conta. */
  readonly obiettivo: number;
  /** le carte di ogni mano: 3, fisso */
  readonly carte: number;
  /** dopo quante mosse d'ufficio CONSECUTIVE dello stesso posto c'e l'abbandono (tempo scaduto = partita persa) */
  readonly ufficioMax: number;
  readonly classificato: boolean;
  readonly turnoMs?: number;
}

/** Una carta giocata in una presa, con chi l'ha giocata. */
export interface Giocata {
  readonly posto: Posto;
  readonly carta: Carta;
}

/** Una presa chiusa: le carte nell'ordine di gioco e chi l'ha vinta. */
export interface Presa {
  readonly giocate: readonly Giocata[];
  readonly vincitore: Posto;
}

/** Il conto di una smazzata finita, pubblico da quando e finita (mai prima). */
export interface Riepilogo {
  readonly smazzata: number;
  readonly mazziere: Posto;
  /** i punti di ogni linea: sommano 120 */
  readonly punti: readonly number[];
  /** la linea con almeno 61 punti, o null per il 60-60 (non conta, si rigioca) */
  readonly vincitore: Linea | null;
}

/** Quello che UN posto vede. Nessun campo porta i punti della smazzata in corso. */
export interface Vista {
  readonly posto: Posto;
  readonly linea: Linea;
  readonly posti: number;
  readonly config: Config;
  readonly fase: Fase;
  readonly smazzata: number;
  readonly mazziere: Posto;
  readonly turno: Posto;
  readonly miaMano: readonly Carta[];
  /** 2v2: la mano del compagno, SOLO a tallone finito (le ultime 3 prese, I-835); sempre null prima, e a 2 posti */
  readonly manoDelCompagno: readonly Carta[] | null;
  /** quante carte ha in mano ogni posto (anche il proprio) */
  readonly carteInMano: readonly number[];
  /** quante carte restano nel tallone, la briscola scoperta compresa finche non e pescata */
  readonly tallone: number;
  /** la briscola: il seme, la carta e il posto che l'ha pescata (null finche sta scoperta sotto il tallone); null fuori da una smazzata */
  readonly briscola: { readonly seme: number; readonly carta: Carta; readonly pescataDa: Posto | null } | null;
  /** la presa in corso; completa (tanti quanti i posti) = da raccogliere, e `turno` e gia chi la vince */
  readonly presa: readonly Giocata[];
  readonly ultimaPresa: Presa | null;
  /** le carte uscite in questa smazzata, in ordine, senza chi le ha giocate ne chi le ha prese (la memoria del robot: la TMA non le disegna) */
  readonly uscite: readonly Carta[];
  readonly smazzateVinte: readonly number[];
  readonly riepiloghi: readonly Riepilogo[];
  readonly vincitore: Linea | null;
}

/** I sotto-codici che il game host puo mettere in `reason` di un rifiuto. La frase la sceglie la TMA. */
export const MOTIVI: readonly string[] = ['CARTA_NON_IN_MANO'];

/** La SOLA azione di una persona: gioca una carta della sua mano. Le chiavi sono esatte: `t`, `posto`, `carta`. */
export interface AzioneDiPersona {
  t: 'GIOCA';
  posto: Posto;
  carta: Carta;
}
